import types from './types';

const start = () => ({
  type: types.START,
});

const started = user => ({
  type: types.START_SUCCESS,
  user,
});

const startFail = error => ({
  type: types.START_FAILURE,
  error,
});

export default {
  start,
  started,
  startFail,
};

export const actions = { start };
